<div class="card dashboard-stats-cards schedule-card">
  <div class="card-header d-flex justify-content-start align-items-center bg-white border-0">
    <div class="schedule-card-header-text font-weight-bold text-primary">
      {{ item.heading |translate | async}}
    </div>
    <div class="schedule-card-header-action">
      @if (formService.questionMapping != undefined && formService.questionMapping.type_filter) {
        <div style="display: inline-block;" class="col-md-12">
          <dhs-form-question [action]="'ADD'"  [validIn]="false" [question]="formService.questionMapping.type_filter" [form]="filterForm"
            (valueChanged)="onFilterValueChanged($event)" >
          </dhs-form-question>
        </div>
      }
      @if (formService.questionMapping != undefined && formService.questionMapping.time_filter) {
        <div style="display: inline-block; margin-left: 5px" class="col-md-12">
          <dhs-form-question [action]="'ADD'"  [validIn]="false" [question]="formService.questionMapping.time_filter" [form]="filterForm"
            (valueChanged)="onFilterValueChanged($event)" >
          </dhs-form-question>
        </div>
      }
    </div>
  </div>
  @if (_chartConfig.chartData.length) {
    <div class="card-body">
      <div class="chart-wrapper mt-3 mx-3" >
        <app-chart [chartDataSets]="_chartConfig.chartData" [chartLabels]="_chartConfig.chartLabels" [chartOptions]="chartOptions"
        [chartColors]="_chartConfig.chartColors" [chartLegend]="item.chartLegend" [chartType]="item.chartType"></app-chart>
      </div>
    </div>
  }
  @if ((_chartConfig.chartData.length == 0)) {
    <div class="card-body">
      Data Not Available
    </div>
  }
</div>